module.exports = __webpack_public_path__ + "static/media/stop-long-icon.04cc21c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/stop-long-icon.svg
// module id = 747
// module chunks = 0